import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { satisfies } from 'semver';
import type { AppState } from '~/reducers';

export const NATIVE_TABBAR_SPACE_PROPERTY = '--fleet-native-tabbar-space';
export const NATIVE_TABBAR_CLEARANCE_PX = 80;
const LIQUID_GLASS_VERSION_RANGE = '>1.6.3';

const clearanceExpression = `calc(env(safe-area-inset-bottom) + ${NATIVE_TABBAR_CLEARANCE_PX}px)`;

/**
 * Publishes `--fleet-native-tabbar-space` on the document root: the bottom clearance
 * scroll containers need under the floating native tab bar. Resolves to a real
 * value only inside the iOS fleet-app > 1.6.3 (edge-to-edge WebView). Otherwise the
 * `:root` fallback of `0px` applies.
 */
const useNativeTabbarSpace = () => {
  const nativeAppInfo = useSelector((state: AppState) => state.native.nativeAppInfo);

  useEffect(() => {
    const needsClearance =
      nativeAppInfo?.platform === 'iOS' &&
      satisfies(nativeAppInfo.version, LIQUID_GLASS_VERSION_RANGE);

    if (needsClearance) {
      document.documentElement.style.setProperty(NATIVE_TABBAR_SPACE_PROPERTY, clearanceExpression);
    }
    return () => {
      document.documentElement.style.removeProperty(NATIVE_TABBAR_SPACE_PROPERTY);
    };
  }, [nativeAppInfo]);
};

export default useNativeTabbarSpace;
